<template>
  <v-container>
    <bread-crumbs :items="breadcrumbs" />

    <h2 class="text-h5 font-weight-bold mb-4">
      Proyectos en {{ area.nombre }}
    </h2>

    <v-data-table
      :headers="headers"
      :items="proyectos"
      class="elevation-1"
    />
  </v-container>
</template>

<script>
import axios from 'axios'
import BreadCrumbs from '@/components/BreadCrumbs.vue'

export default {
  name: 'ProyectosView',
  components: { BreadCrumbs },
  props: ['clienteId', 'areaId'],
  data() {
    return {
      cliente: {},
      area: {},
      proyectos: [],
      headers: [
        { text: 'ID',     value: 'id'     },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Estado', value: 'estado' }
      ]
    }
  },
  computed: {
    breadcrumbs() {
      return [
        { text: 'CLIENTES', to: { name: 'Clientes' } },
        {
          text: this.cliente.nombre,
          to: {
            name: 'Areas',
            params: { clienteId: this.clienteId }
          }
        },
        { text: this.area.nombre }
      ]
    }
  },
  async created() {
    try {
      // 1) Obtener datos de cliente y área usando /clients
      const [{ data: c }, { data: a }] = await Promise.all([
        axios.get(`/clients/${this.clienteId}`),
        axios.get(`/clients/${this.clienteId}/areas/${this.areaId}`)
      ])
      this.cliente = c
      this.area = a

      // 2) Cargar proyectos desde /clients/:clienteId/areas/:areaId/proyectos
      const { data: p } = await axios.get(
        `/clients/${this.clienteId}/areas/${this.areaId}/proyectos`
      )
      this.proyectos = p
    } catch (err) {
      console.error('Error cargando proyectos:', err)
    }
  }
}
</script>

<style scoped>
</style>
